import React from 'react';
import PropTypes from 'prop-types';
import find from 'lodash.find';
import get from 'lodash.get';
import { createFragmentContainer, graphql } from 'react-relay';
import ContextComponent from '../ContextComponent';
import style from './ConnectBoardModal-style.scss';

// Components
import Select from 'dibs-elements/dist/Select';
import 'dibs-elements/dist/Select/buyer/Default.css';

import SanitizeHtml from '../SanitizeHtml';

import PrimaryButton from 'dibs-elements/dist/Button/Primary';
import BarHeader from 'dibs-elements/dist/BarHeader';
import ModalBody from 'dibs-elements/dist/ModalBody';
import ModalCloseButton from 'dibs-elements/dist/ModalCloseButton';
import ModalContainer from 'dibs-elements/dist/ModalContainer';

// Actions
import pinterestUtils from '../../utils/social/pinterest';

import ModifyPinterestBoardMutation from './ModifyPinterestBoardMutation';

import findConnectedBoard from './findConnectedBoard';

class PinterestConnectBoardModal extends ContextComponent {
    constructor(props) {
        super(props);

        this.onBoardChange = this.onBoardChange.bind(this);
        this.doneClick = this.doneClick.bind(this);
        this.close = this.close.bind(this);

        this.state = {
            boardId: 'default',
            boardName: this.getDefaultBoardName(),
        };
    }

    componentWillReceiveProps(nextProps) {
        const boards = get(nextProps, 'userSocialNetwork.pinterest.boards') || [];
        const userBoard = get(nextProps, 'userSocialNetwork.userPreferences.board');
        const selectedBoard = boards.find(board => board.url.indexOf(userBoard) > -1);

        if (selectedBoard) {
            this.setState({
                boardId: selectedBoard.serviceId,
                boardName: selectedBoard.name,
            });
        }
    }

    getDefaultBoardName() {
        return get(this.props, 'copy.defaultBoardName');
    }

    findDefaultBoard(props) {
        const boards = get(props, 'userSocialNetwork.pinterest.boards');
        const defaultBoard = find(boards || [], board => {
            return board.name === this.getDefaultBoardName();
        });

        return defaultBoard;
    }

    close(event) {
        const { onClose } = this.props;
        if (event) {
            event.preventDefault();
        }

        const { connectedBoard } = findConnectedBoard(this.props);

        if (!connectedBoard) {
            this.saveBoard();
        }

        onClose();
    }

    doneClick() {
        const { boardName } = this.state;
        const { onClose, tracking } = this.props;

        this.saveBoard();

        const { connectedBoardName } = findConnectedBoard(this.props);

        if (
            (connectedBoardName && boardName === connectedBoardName) ||
            (!connectedBoardName && boardName === this.getDefaultBoardName())
        ) {
            pinterestUtils.track(tracking.boardUnchanged);
        } else {
            pinterestUtils.track(tracking.boardUpdated);
        }

        onClose();
    }

    onBoardChange(selectedItems) {
        const { label, value } = selectedItems;
        this.setState({
            boardId: value,
            boardName: label,
        });
    }

    saveBoard() {
        const { boardId, boardName } = this.state;
        const { relay, userId } = this.props;
        let payload;

        if (boardId === 'default') {
            payload = { userId, boardName };
        } else {
            payload = { userId, boardId };
        }

        ModifyPinterestBoardMutation.commit(relay.environment, payload);
    }

    /**
     * Gets pinterest boards and checks if default board name is among saved boards,
     * if not then ushifts (puts default board name to first array position) boards array
     * with default board data
     * @return {Array} pinterest boards
     */
    getBoardOptions() {
        const boardsCopy = (get(this.props, 'userSocialNetwork.pinterest.boards') || []).slice(0);
        const defaultBoardName = this.getDefaultBoardName();
        const defaultBoard = this.findDefaultBoard(this.props);

        if (!defaultBoard) {
            boardsCopy.unshift({
                serviceId: 'default',
                name: defaultBoardName,
            });
        }

        return boardsCopy.map(board => ({ value: board.serviceId, label: board.name }));
    }

    render() {
        const { isOpen, copy, error } = this.props;
        const { boardId } = this.state;
        let errorMessage = null;

        if (error) {
            errorMessage = (
                <div className={style.error}>
                    <SanitizeHtml content={copy.boardConflict} />
                </div>
            );
        }

        return (
            <ModalContainer isOpen={isOpen} onClose={this.close} closeOnEsc modalPosition="center">
                <BarHeader title={copy.header} />
                <ModalCloseButton onClick={this.close} />
                <ModalBody>
                    <div className="modal-simple-message">
                        <SanitizeHtml content={copy.message} />
                    </div>

                    {errorMessage}

                    <label className={style.fieldLabel}>Board Name</label>
                    <div className={style.fieldInput}>
                        <Select
                            name="board"
                            onChange={this.onBoardChange}
                            // searchable={false}
                            clearable={false}
                            value={boardId}
                            options={this.getBoardOptions()}
                        />
                    </div>

                    <div className={style.fieldSubHeader}>
                        <SanitizeHtml content={copy.hint} />
                    </div>

                    <PrimaryButton size="medium" onClick={this.doneClick} className={style.button}>
                        {copy.cta}
                    </PrimaryButton>
                </ModalBody>
            </ModalContainer>
        );
    }
}

PinterestConnectBoardModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    // error: PropTypes.bool.isRequired,
    // connectedBoard: PropTypes.object,
    // boards: PropTypes.array.isRequired,
    copy: PropTypes.object.isRequired,
    tracking: PropTypes.object,
    style: PropTypes.shape({
        content: PropTypes.object,
        overlay: PropTypes.object,
    }),
};

export default createFragmentContainer(PinterestConnectBoardModal, {
    userSocialNetwork: graphql`
        fragment PinterestConnectBoardModal_userSocialNetwork on PinterestSocialNetwork {
            pinterest {
                boards {
                    serviceId
                    name
                    url
                }
            }
            userPreferences {
                board
            }
        }
    `,
});



// WEBPACK FOOTER //
// ./assets/js/global/components/Pinterest/PinterestConnectBoardModal.jsx